export default __webpack_public_path__ + "static/media/button talkback-10.efafca80.png";